/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Created_ByInputs */

const en_tables_custom_properties_created_by = /** @type {(inputs: Tables_Custom_Properties_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Created By`)
};

const de_tables_custom_properties_created_by = /** @type {(inputs: Tables_Custom_Properties_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created von`)
};

/**
* | output |
* | --- |
* | "Properties Created By" |
*
* @param {Tables_Custom_Properties_Created_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_created_by = /** @type {((inputs?: Tables_Custom_Properties_Created_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Created_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_created_by(inputs)
	return de_tables_custom_properties_created_by(inputs)
});